import { contentPaneLabel } from 'owa-locstrings/lib/strings/contentpanelabel.locstring.json';
import loc from 'owa-localize';
import Compose from './Compose';
import Dock from './Dock';
import { observer } from 'mobx-react';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import { createInitialActions, executeInitialActions, InitialActions } from 'owa-initial-actions';
import { findComposePlugins } from 'owa-mail-compose-actions/lib/plugins/ComposePlugins';
import { ComposeViewState } from 'owa-mail-compose-store';
import { isSubjectPickerSupported } from 'owa-mail-subject-picker-connector/lib/utils/isSubjectPickerSupported';

import * as React from 'react';

const styles = require('./composeCommon.scss');
const classNames = require('classnames/bind').bind(styles);

export interface FullComposeProps {
    viewState: ComposeViewState;
}

@observer
export default class FullCompose extends React.Component<FullComposeProps, {}> {
    initialActions: InitialActions;

    constructor(props: FullComposeProps) {
        super(props);
        this.initialActions = createInitialActions();
    }

    componentDidMount() {
        executeInitialActions(this.initialActions);
    }

    render() {
        const viewState = this.props.viewState;
        const scrollContainerClasses = classNames(styles.scrollContainer, 'customScrollBar', {
            sticky: viewState.docking.useStickyDocking,
        });
        const composePlugins = findComposePlugins(viewState);
        const scrollAdapter = composePlugins && composePlugins.dockingPlugin.getScrollAdapter();
        return (
            <div tabIndex={-1} role={'main'} aria-label={loc(contentPaneLabel)}>
                <Compose
                    viewState={viewState}
                    className={scrollContainerClasses}
                    initialActions={this.initialActions}
                    ref={ref =>
                        scrollAdapter &&
                        scrollAdapter.setScrollContainer(ref ? ref.getRootDiv() : null)
                    }>
                    <div className={styles.scrollRegionBottomBuffer} />
                </Compose>
                {this.renderSubjectPickerConversationLoadingIndicator()}
                <Dock viewState={viewState} initialActions={this.initialActions} />
            </div>
        );
    }

    private renderSubjectPickerConversationLoadingIndicator(): JSX.Element {
        if (
            isSubjectPickerSupported() &&
            this.props.viewState.subjectPickerViewState.isLoadingConversation
        ) {
            return (
                <div className={styles.conversationLoadingOverlay}>
                    <Spinner className={styles.conversationLoadingSpinner} />
                </div>
            );
        }

        return null;
    }
}
